import { isErrorResponse } from '@ori-events/failed-event-data';
export const Name = 'accept-notification-failed';
export const AcceptNotificationFailedEvent = Name;
export const isAcceptNotificationErrorResponse = response => isErrorResponse(response);
//# sourceMappingURL=index.js.map